export default __webpack_public_path__ + "static/media/480_dummy2016-anwaltskanzlei01-de.78acaf18.png";